export const UploadStatusMessages = {
  InvalidFile: 'Invalid file',
  FileTooLarge: 'File exceeds size limit',
  UnsupportedFileType: 'Unsupported file type'
};

const Completed = 'Completed';
const Failed = 'Failed';
const Uploading = 'Uploading';

export const UploadStatusTypes = {
  Completed,
  Failed,
  Uploading
};

export default {
  UploadStatusMessages,
  UploadStatusTypes
};
